import app from './app.config';
import auth from './auth.config';
import flybase from './flybase.config';
import sentry from './sentry.config';

export default {
  app,
  auth,
  flybase,
  sentry,
  isProduction: import.meta.env.PROD,
};
